import api from '../api/api';

const API_URL = '/api/v1';

// --- Interfaces ---

export interface Role {
    id: number;
    nome: string;
}

export interface Usuario {
    id: number;
    nome: string;
    login: string;
    roles: Role[];
}

export interface UsuarioDTO {
    id?: number;
    nome: string;
    login: string;
    senha?: string;
    roleIds: number[];
}

// --- Facade ---

export const UsuarioFacade = {
    listarTodos: async (): Promise<Usuario[]> => {
        const response = await api.get(`${API_URL}/usuarios`);
        return response.data;
    },

    criar: async (usuario: UsuarioDTO): Promise<Usuario> => {
        const response = await api.post(`${API_URL}/usuarios`, usuario);
        return response.data;
    },

    atualizar: async (id: number, usuario: UsuarioDTO): Promise<Usuario> => {
        const response = await api.put(`${API_URL}/usuarios/${id}`, usuario);
        return response.data;
    },

    excluir: async (id: number): Promise<void> => {
        await api.delete(`${API_URL}/usuarios/${id}`);
    }
};

export const RoleFacade = {
    listarTodos: async (): Promise<Role[]> => {
        const response = await api.get(`${API_URL}/roles`);
        return response.data;
    }
};